import { render, staticRenderFns } from "./ChooseNewPayoutMethod.vue?vue&type=template&id=7e3974f0&"
import script from "./ChooseNewPayoutMethod.vue?vue&type=script&lang=js&"
export * from "./ChooseNewPayoutMethod.vue?vue&type=script&lang=js&"
import style0 from "./ChooseNewPayoutMethod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports